import {NavigationPathKey, TranslationKey} from '@enums'
import {SearchTableWrapper} from '@wrappers'

import React from 'react'

import {UIKit} from '@components'

import {useContractTemplateSearchModel} from './contract-template-search-model'

/**
 * Contract Template Search page
 */
export function ContractTemplateSearchPage() {
  const {rows, columns, t, showCreateButton, navigate} = useContractTemplateSearchModel()

  return (
    <SearchTableWrapper>
      <UIKit.Table
        {...(showCreateButton && {
          buttonProps: {
            buttonText: t(TranslationKey['Add new contract template']),
            onClick: () => navigate(NavigationPathKey.CONTRACT_TEMPLATE_CREATION),
          },
        })}
        columns={columns}
        rows={rows}
        title={t(TranslationKey['List of contract templates'])}
      />
    </SearchTableWrapper>
  )
}
